import StateInterface from "../state-interface";

export const ai_boost_b2b_leads: StateInterface["ai_boost_b2b_leads"] = {
    _id: "",
    name: "John Doe",
    phone: {
        phone_number: "08012345678",
        country_code: "234",
    },
    source: {
        url: "https://example.com",
        component: "website",
        form_type: "contact_form",
    },
    status: "new",
    notes: "",
    comments: "",
    budget: 0,
    created_at: "2020-11-01T12:00:00.000Z",
    updated_at: "2020-11-01T12:00:00.000Z",
    contact_preferences: "anytime",
    properties_to_boost: [],
    assigned_to: [],
    activity_log: [],
    enquiry_count: 0,
    last_enquiry_at: "",

};
